import { RouterLink } from '@redux-first-router-link';
import {
  useCloudflareImage,
  getResponsiveImage,
} from '@/hooks/useCloudflareImage';
import { useTracking } from 'react-tracking';
import { CoverImage } from './styled';
import { ROUTE_ARTICLE } from '@/constants/routes';

type Props = {
  slug: string;
  title: string;
  imageUrl: string;
  index: number;
};

export const CardImage = ({ title, imageUrl, slug, index }: Props) => {
  const { trackEvent } = useTracking();

  const coverImageSrc = useCloudflareImage({
    src: imageUrl,
    width: 310,
    height: 175,
    fit: 'cover',
  });

  const { srcSet: coverImageSrcSet } = getResponsiveImage({
    src: imageUrl,
    breakpoints: [{ width: 310, height: 175, fit: 'cover' }],
  });

  return (
    <RouterLink
      data-cy-id={`article-card-image-link-${index}`}
      to={{ type: ROUTE_ARTICLE, payload: { slug } }}
      inheritColor
      noUnderline={false}
      onClick={() =>
        trackEvent({
          type: 'track',
          action: 'click',
          subject: 'Link to article',
        })
      }
    >
      <CoverImage
        src={coverImageSrc}
        srcSet={coverImageSrcSet}
        width="100%"
        height={175}
        alt={title + ' cover'}
      ></CoverImage>
    </RouterLink>
  );
};
